function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "smartwatch-app"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M16.734,31.069a10.8,10.8,0,0,1,.279-2.4,7.533,7.533,0,0,1-2.173.318H7.578A7.539,7.539,0,0,1,5.4,28.667a10.8,10.8,0,0,1,.279,2.4,1.263,1.263,0,0,1-2.526,0,10.212,10.212,0,0,0-1.533-4.978A7.544,7.544,0,0,1,0,21.407V10.861A7.546,7.546,0,0,1,1.748,6.026,9.557,9.557,0,0,0,3.157,1.263a1.263,1.263,0,0,1,2.526,0A10.74,10.74,0,0,1,5.42,3.6a7.561,7.561,0,0,1,2.158-.312H14.84A7.559,7.559,0,0,1,17,3.6a10.74,10.74,0,0,1-.264-2.334,1.263,1.263,0,0,1,2.526,0,9.557,9.557,0,0,0,1.409,4.763,7.554,7.554,0,0,1,1.681,3.826h.7a1.263,1.263,0,0,1,0,2.525h-.632V14.9h.632a1.263,1.263,0,0,1,0,2.525h-.632v3.979a7.539,7.539,0,0,1-1.626,4.685,10.21,10.21,0,0,0-1.531,4.976,1.263,1.263,0,0,1-2.526,0Z",
  fill: "#fff"
}));

function SvgDesktopI6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.305,
    height: 32.332,
    viewBox: "0 0 24.305 32.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopI6);
export default __webpack_public_path__ + "static/media/desktopI6.e5f55ae1.svg";
export { ForwardRef as ReactComponent };